export default "__VITE_ASSET__DJfFt42H__"